var map = {
	"./advertising.webp": 45362,
	"./alexa.webp": 3815,
	"./amazon_store.webp": 6634,
	"./amc.webp": 5743,
	"./aws.webp": 63981,
	"./kdp.webp": 81917,
	"./reviews.webp": 26853,
	"./sponsored_brands.webp": 19002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63920;